import { alpha, Box, styled } from '@mui/material'

export const viewGridClasses = {
  root: 'DinoViewGrid-root',
  normal: 'DinoViewGrid-normal',
  autoHeight: 'DinoViewGrid-autoHeight',
  virtualized: 'DinoViewGrid-virtualized',
  scrollContainer: 'DinoViewGrid-scrollContainer',
  grid: 'DinoViewGrid-grid',
  gridItem: 'DinoViewGrid-item',
  // Statuses
  scrolling: 'DinoViewGrid-scrolling'
}
const classes = viewGridClasses

export const ViewGridStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  flex: 1,
  minHeight: 0,
  minWidth: 0,
  position: 'relative',
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  boxSizing: 'border-box',
  [`.${classes.scrollContainer}`]: {
    width: '100%',
    height: '100%',
    overflowY: 'auto',
    overflowAnchor: 'none',
    padding: theme.spacing(0.5),
    // Scrollbar styling
    '&::-webkit-scrollbar': { width: 6, height: 6 },
    '&::-webkit-scrollbar-thumb': { backgroundColor: theme.palette.grey[400] },
    '&::-webkit-scrollbar-thumb:hover': { backgroundColor: theme.palette.grey[600] },
    '&::-webkit-scrollbar-track': { backgroundColor: theme.palette.grey[200], borderRadius: 4 },
    '&::-webkit-scrollbar-track:hover': { backgroundColor: theme.palette.grey[300] }
  },
  [`.${classes.scrollContainer}::before`]: {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: theme.spacing(1.5),
    background: `linear-gradient(
      to bottom,
      ${theme.palette.background.paper} 0%,
      ${alpha(theme.palette.background.paper, 0.16)} 30%,
      transparent 100%
    )`,
    pointerEvents: 'none',
    // animation
    opacity: 0,
    visibility: 'hidden',
    transition: 'all 0.3s ease-out',
    zIndex: theme.zIndex.appBar - 1
  },
  [`&.${classes.scrolling} .${classes.scrollContainer}::before`]: {
    opacity: 1,
    visibility: 'visible'
  },
  // Auto-height variant: disable the internal scroll container and let the
  // component size expand with content. This makes the table render all
  // rows and removes the internal scrollbar used in 'normal' modes.
  [`&.${classes.normal}.${classes.autoHeight}`]: {
    height: 'auto',
    overflow: 'visible',
    [`.${classes.scrollContainer}`]: {
      position: 'static',
      inset: 'auto',
      overflowY: 'visible'
    }
  }
}))
